export const Features = {
  // Content Adjustment
  CONTENT_HIGHLIGHT_LINKS: 'CONTENT_HIGHLIGHT_LINKS',
  CONTENT_BIGGER_TEXT: 'CONTENT_BIGGER_TEXT',
  CONTENT_BIGGER_TEXT_3XL: 'CONTENT_BIGGER_TEXT_3XL',
  CONTENT_BIGGER_TEXT_2XL: 'CONTENT_BIGGER_TEXT_2XL',
  CONTENT_BIGGER_TEXT_XL: 'CONTENT_BIGGER_TEXT_XL',
  CONTENT_TEXT_SPACING: 'CONTENT_TEXT_SPACING',
  CONTENT_TEXT_SPACING_HEAVY: 'CONTENT_TEXT_SPACING_HEAVY',
  CONTENT_TEXT_SPACING_MODERATE: 'CONTENT_TEXT_SPACING_MODERATE',
  CONTENT_TEXT_SPACING_LIGHT: 'CONTENT_TEXT_SPACING_LIGHT',
  CONTENT_LINE_HEIGHT: 'CONTENT_LINE_HEIGHT',
  CONTENT_LINE_HEIGHT_2X: 'CONTENT_LINE_HEIGHT_2X',
  CONTENT_LINE_HEIGHT_1_75X: 'CONTENT_LINE_HEIGHT_1_75X',
  CONTENT_LINE_HEIGHT_1_5X: 'CONTENT_LINE_HEIGHT_1_5X',
  CONTENT_DYSLEXIC_FRIENDLY: 'CONTENT_DYSLEXIC_FRIENDLY',
  CONTENT_LEGIBLE_FONTS: 'CONTENT_LEGIBLE_FONTS',
  CONTENT_DYSLEXIC_FONT: 'CONTENT_DYSLEXIC_FONT',
  CONTENT_TEXT_ALIGN: 'CONTENT_TEXT_ALIGN',
  CONTENT_ALIGN_CENTER: 'CONTENT_ALIGN_CENTER',
  CONTENT_ALIGN_LEFT: 'CONTENT_ALIGN_LEFT',
  CONTENT_ALIGN_RIGHT: 'CONTENT_ALIGN_RIGHT',
  CONTENT_ALIGN_JUSTIFY: 'CONTENT_ALIGN_JUSTIFY',

  // Color & Contrast
  COLOR_SATURATION: 'COLOR_SATURATION',
  COLOR_HIGH_SATURATION: 'COLOR_HIGH_SATURATION',
  COLOR_LOW_SATURATION: 'COLOR_LOW_SATURATION',
  COLOR_DESATURATE: 'COLOR_DESATURATE',
  COLOR_CONTRAST_MODE: 'COLOR_CONTRAST_MODE',
  COLOR_LIGHT_CONTRAST: 'COLOR_LIGHT_CONTRAST',
  COLOR_DARK_CONTRAST: 'COLOR_DARK_CONTRAST',
  COLOR_SMART_CONTRAST: 'COLOR_SMART_CONTRAST',

  // Navigation & Reading Aids
  NAVIGATION_SCREEN_READER: 'NAVIGATION_SCREEN_READER',
  NAVIGATION_READ_FAST: 'NAVIGATION_READ_FAST',
  NAVIGATION_READ_SLOW: 'NAVIGATION_READ_SLOW',
  NAVIGATION_VOICE_NAVIGATION: 'NAVIGATION_VOICE_NAVIGATION',
  NAVIGATION_PAUSE_ANIMATION: 'NAVIGATION_PAUSE_ANIMATION',
  NAVIGATION_HIDE_IMAGES: 'NAVIGATION_HIDE_IMAGES',
  NAVIGATION_BIG_CURSOR: 'NAVIGATION_BIG_CURSOR',
  NAVIGATION_DARK_CURSOR: 'NAVIGATION_DARK_CURSOR',
  NAVIGATION_READING_MASK: 'NAVIGATION_READING_MASK',
  NAVIGATION_READING_GUIDE: 'NAVIGATION_READING_GUIDE',
  NAVIGATION_PAGE_STRUCTURE: 'NAVIGATION_PAGE_STRUCTURE',
  NAVIGATION_DICTIONARY: 'NAVIGATION_DICTIONARY',
  NAVIGATION_KEY_NAVIGATION: 'NAVIGATION_KEY_NAVIGATION',
  NAVIGATION_TOOLTIPS: 'NAVIGATION_TOOLTIPS',
  NAVIGATION_MUTE_SOUND: 'NAVIGATION_MUTE_SOUND',
  NAVIGATION_HIDE_INTERFACE: 'NAVIGATION_HIDE_INTERFACE',
  NAVIGATION_SHOW_INTERFACE: 'NAVIGATION_SHOW_INTERFACE',
  NAVIGATION_RESET: 'NAVIGATION_RESET',

  // Accessibility Profiles
  PROFILE_BLIND: 'PROFILE_BLIND',
  PROFILE_SEIZURE_EPILEPTIC: 'PROFILE_SEIZURE_EPILEPTIC',
  PROFILE_LOW_VISION: 'PROFILE_LOW_VISION',
  PROFILE_MOTOR_IMPAIRED: 'PROFILE_MOTOR_IMPAIRED',
  PROFILE_COGNITIVE_LEARNING: 'PROFILE_COGNITIVE_LEARNING',
  PROFILE_ADHD: 'PROFILE_ADHD',
  PROFILE_DYSLEXIA: 'PROFILE_DYSLEXIA',
  PROFILE_COLOR_BLIND: 'PROFILE_COLOR_BLIND',

  // Other
  DEFAULT: 'DEFAULT'
} as const;

export type Feature = typeof Features[keyof typeof Features];
